import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface ErrorTextProps {
    children: ReactNode
    size?: 'xs' | 'sm' | 'base'
    truncate?: boolean
    title?: string
    className?: string
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const sizeClasses = {xs: 'text-xs', sm: 'text-sm', base: ''}
/* eslint-enable i18next/no-literal-string */

export function ErrorText({children, size = 'base', truncate, title, className, 'data-testid': testId}: ErrorTextProps) {
    return (
        <span
            className={cn('text-destructive', sizeClasses[size], truncate && 'truncate block', className)}
            title={title}
            data-testid={testId}
        >
            {children}
        </span>
    )
}
